export const PROFILES_LOADED = 'PROFILES_LOADED';
export const PROMPT_PICK_PROFILE = 'PROMPT_PICK_PROFILE';
export const PROFILE_SELECTED = 'PROFILE_SELECTED';
export const CLOSE_PROFILE_PROMPT = 'CLOSE_PROFILE_PROMPT';
export const SET_STARTING_USERID = 'SET_STARTING_USERID';
